import {
  OBTENER_DIRECCIONES_SUCCESS,
  OBTENER_DIRECCIONES_ERROR,
  VALIDAR_AFILIADO_SUCCESS,
  VALIDAR_AFILIADO_ERROR,
  VALIDAR_AFILIADO_INMEDIATA_SUCCESS,
  VALIDAR_AFILIADO_INMEDIATA_ERROR,
  GUARDAR_DATOS_SUCCESS,
  GUARDAR_DATOS_ERROR,
  GUARDAR_DATOS_INMEDIATA_SUCCESS,
  GUARDAR_DATOS_INMEDIATA_ERROR,
  OBTENER_PRESTACIONES_SUCCESS,
  OBTENER_PRESTACIONES_ERROR,
  OBTENER_CODIGO_DIAGNOSTICO_SUCCESS,
  OBTENER_CODIGO_DIAGNOSTICO_ERROR,
  VALIDAR_DIRECCION_SUCCESS,
  VALIDAR_DIRECCION_ERROR,
  VALIDAR_COBERTURA_SUCCESS,
  VALIDAR_COBERTURA_ERROR,
  VALIDAR_DIRECCION_INMEDIATA_SUCCESS,
  VALIDAR_DIRECCION_INMEDIATA_ERROR,
  GET_CIRCLE_DATA_SUCCESS,
  GET_CIRCLE_DATA_ERROR,
  GUARDAR_DATOS_CENSOS_SUCCESS,
  GUARDAR_DATOS_CENSOS_ERROR,
} from '../constants';

export default function altaDeAutorizaciones(state = {}, action) {
  const newState = { ...state };
  switch (action.type) {
    case GUARDAR_DATOS_SUCCESS:
      newState.guardarDatos = action.data;
      return newState;
    case GUARDAR_DATOS_ERROR:
      newState.guardarDatos = action.data?.message ? action.data : 'Error';
      return newState;
    case GUARDAR_DATOS_INMEDIATA_SUCCESS:
      newState.guardarDatosInmediata = action.data;
      return newState;
    case GUARDAR_DATOS_INMEDIATA_ERROR:
      newState.guardarDatosInmediata = 'Error';
      return newState;
    case VALIDAR_DIRECCION_SUCCESS:
      newState.validarDireccion = action.data;
      return newState;
    case VALIDAR_DIRECCION_ERROR:
      newState.validarDireccion = 'Error';
      return newState;
    case VALIDAR_COBERTURA_SUCCESS:
      newState.cobertura = action.data;
      return newState;
    case GET_CIRCLE_DATA_ERROR:
      newState.circleData = 'Error';
      return newState;
    case GET_CIRCLE_DATA_SUCCESS:
      newState.circleData = action.data;
      return newState;
    case VALIDAR_COBERTURA_ERROR:
      newState.cobertura = 'Error';
      return newState;
    case VALIDAR_DIRECCION_INMEDIATA_SUCCESS:
      newState.validarDireccionInmediata = action.data;
      return newState;
    case VALIDAR_DIRECCION_INMEDIATA_ERROR:
      newState.validarDireccionInmediata = 'Error';
      return newState;
    case OBTENER_DIRECCIONES_SUCCESS:
      newState.direcciones = action.data;
      return newState;
    case OBTENER_DIRECCIONES_ERROR:
      newState.direcciones = 'Error';
      return newState;
    case VALIDAR_AFILIADO_SUCCESS:
      newState.validarAfiliado = action.data;
      return newState;
    case VALIDAR_AFILIADO_ERROR:
      newState.validarAfiliado = { isValid: false };
      return newState;
    case VALIDAR_AFILIADO_INMEDIATA_SUCCESS:
      newState.validarAfiliadoInmediata = action.data;
      return newState;
    case VALIDAR_AFILIADO_INMEDIATA_ERROR:
      newState.validarAfiliadoInmediata = { isValid: false };
      return newState;
    case OBTENER_CODIGO_DIAGNOSTICO_SUCCESS:
      newState.diagnosticos = action.data;
      return newState;
    case OBTENER_CODIGO_DIAGNOSTICO_ERROR:
      newState.diagnosticos = [];
      return newState;
    case GUARDAR_DATOS_CENSOS_SUCCESS:
      newState.guardarDatosCensos = action.data;
      return newState;
    case GUARDAR_DATOS_CENSOS_ERROR:
      newState.guardarDatosCensos = 'Error';
      return newState;
    case OBTENER_PRESTACIONES_SUCCESS:
      newState.prestaciones = action.data;
      return newState;
    case OBTENER_PRESTACIONES_ERROR:
      newState.prestaciones = [];
      return newState;
    default:
      return newState;
  }
}
